import { useState, useRef } from "react";
import {
  XMarkIcon,
  MagnifyingGlassIcon,
  ChevronRightIcon,
  SquaresPlusIcon,
  DocumentMagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

const SearchableExerciseList = ({ exercises }) => {
  const [filterText, setFilterText] = useState("");
  const exerciseSearchInputRef = useRef(null);

  const handleFilterChange = (event) => {
    setFilterText(event.target.value);
  };

  const handleClearFilter = () => {
    setFilterText("");
    exerciseSearchInputRef.current.focus();
  };

  const filteredData = exercises.filter((exercise) =>
    exercise.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <>
      <h1 className="text-base font-medium text-gray-900 mb-1">
        Select an exercise to see your progress
      </h1>
      <div className="relative">
        <MagnifyingGlassIcon
          className="h-5 w-auto text-gray-400 absolute top-[19px] -translate-y-1/2 left-3 pointer-events-none"
          aria-hidden="true"
        />
        <input
          name="exercise-search"
          type="text"
          autoComplete="off"
          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 text-sm px-10"
          placeholder="Search for an exercise"
          value={filterText}
          onChange={handleFilterChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.target.blur();
            }
          }}
          ref={exerciseSearchInputRef}
        />
        {filterText && (
          <button
            className="absolute top-[19px] -translate-y-1/2 right-3"
            onClick={handleClearFilter}
          >
            <XMarkIcon
              className="h-5 w-auto text-gray-400"
              aria-hidden="true"
            />
          </button>
        )}
      </div>
      <div className="flex gap-1 mt-4">
        <h2 className="text-base font-medium text-gray-900">Exercises</h2>
        <div className="flex justify-center justify-items-center align-middle items-center bg-gray-900 rounded-xl px-2">
          <p className="text-white text-xs leading-3">{filteredData.length}</p>
        </div>
      </div>
      <div
        className={`overflow-y-scroll h-[calc(100vh-248px)] mt-2 flex flex-col items-center ${
          filteredData.length === 0 ? "justify-center" : ""
        }`}
      >
        {filteredData.map((item, index) => (
          <Link
            key={index}
            className="p-2 bg-white rounded-md shadow-sm mb-1 border border-gray-300 flex items-center w-full last:mb-2"
            to={`/progress/exercise?name=${item}`}
          >
            <h3 className="text-base font-medium text-gray-900 w-full whitespace-nowrap overflow-hidden text-ellipsis">
              {item}
            </h3>
            <ChevronRightIcon
              className="h-5 w-auto text-gray-900"
              aria-hidden="true"
            />
          </Link>
        ))}

        {exercises.length === 0 && (
          <div className="w-full flex flex-col items-center gap-y-2 text-center p-3 mb-20">
            <SquaresPlusIcon
              className="h-10 w-10 text-gray-400"
              aria-hidden="true"
            />
            <h3 className="text-sm font-medium text-gray-900 mt-2 mb-1">
              No Exercises Tracked
            </h3>
            <p className="text-sm text-gray-500 text-center">
              Start tracking your exercise progress by
              <br />
              <Link to="/create-workout" className="text-indigo-500 underline">
                creating a new workout log
              </Link>
            </p>
          </div>
        )}
        {exercises.length !== 0 &&
          filterText.length !== 0 &&
          filteredData.length === 0 && (
            <div className="w-full flex flex-col items-center gap-y-2 text-center p-3 mb-20">
              <DocumentMagnifyingGlassIcon
                className="h-10 w-10 text-gray-400"
                aria-hidden="true"
              />
              <h3 className="text-sm font-medium text-gray-900 mt-2 mb-1">
                No Exercises Found
              </h3>
              <p className="text-sm text-gray-500 text-center">
                {`'${filterText}' did not match any of your exerercises.`}
                <br />
                Please try again.
              </p>
            </div>
          )}
      </div>
    </>
  );
};

export default SearchableExerciseList;
